/* RESPONSIBLE TEAM: team-inbox-experience */
import { helper as buildHelper } from '@ember/component/helper';
import displayAdminAs from 'embercom/lib/inbox/display-admin-as';

export default buildHelper(function (params) {
  return displayAdminAs(params[0], params[1], params[2], params[3], params[4]);
});
